import { ZealApiSuccessResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPostRecentlyViewedPagesSnapshotArgs,
  IPostRecentlyViewedPagesSnapshotResponseData,
} from "./postRecentlyViewedPagesSnapshot.schema";

type SuccessResponse =
  ZealApiSuccessResponse<IPostRecentlyViewedPagesSnapshotResponseData>;

export const postRecentlyViewedPagesSnapshot = (axios: IAxiosInstance) => {
  return async (params: IPostRecentlyViewedPagesSnapshotArgs) => {
    try {
      const response = await axios.noRetry.post<SuccessResponse>(
        "/api/recently-viewed-pages/snapshot",
        params
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
